import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'tr' ? 'en' : 'tr';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="px-4 py-2 rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors border border-gray-700"
      title={i18n.language === 'tr' ? 'Switch to English' : 'Türkçeye Geç'}
    >
      <span className="text-sm font-medium text-gray-300">
        {i18n.language === 'tr' ? 'EN' : 'TR'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
